import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { CaseFormState } from '../../states/case-form.state';
import { AddFieldCommand } from './add-field.command';

/**
 * Add Field Use Case
 * Adds a field to a form version
 */
@Injectable({ providedIn: 'root' })
export class AddFieldUseCase {
  private readonly _repository = inject(CaseFormRepository);
  private readonly _state = inject(CaseFormState);

  public execute(command: AddFieldCommand): Observable<{ id: string }> {
    this._state.setLoadingCaseForm(true);
    this._state.clearErrorCaseForms();

    return this._repository.addField(command.versionId, command.field).pipe(
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          `Failed to add field to version ${command.versionId}`;
        this._state.setErrorCaseForms(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingCaseForm(false))
    );
  }
}
